export default __webpack_public_path__ + "static/media/second-strip.3f10583d.png";